
function toPercentage(a, b) {
    return parseInt(parseFloat(a) / parseFloat(b) * 100)
}
